var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n\tTitlePageComponent \n\tjustify-space-between \n\talign-center\n\tHideOnMovil\n\t"},[_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"Actions"},[_c('Searcher'),_c('Notifications')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }